import React, { useEffect, useState } from 'react';
import api from '../api';

function Cases() {
  const [cases, setCases] = useState([]);

  useEffect(() => {
    api.get('/api/releases').then(res => {
      const releases = res.data || [];
      const active = releases.filter(r => r.status !== 'final_approved' && r.status !== 'rejected');
      setCases(active);
    });
  }, []);

  return (
    <div>
      <h2>Active Cases</h2>
      <p>All pending release requests that require attention.</p>
      {cases.length === 0 ? (
        <p>No active cases at the moment.</p>
      ) : (
        <div className="table-box">
          <table>
            <thead>
              <tr>
                <th>Asset</th>
                <th>Amount</th>
                <th>To</th>
                <th>Risk</th>
                <th>Compliance</th>
                <th>Management</th>
                <th>Final</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {cases.map(r => (
                <tr key={r.id}>
                  <td>{r.Asset?.txHash?.slice(0, 8)}...</td>
                  <td>{r.amount} ETH</td>
                  <td>{r.destinationAddress?.slice(0, 8)}...</td>
                  <td style={{ color: r.riskApprovedBy ? 'green' : 'orange' }}>
                    {r.riskApprovedBy ? 'Approved' : 'Pending'}
                  </td>
                  <td style={{ color: r.complianceApprovedBy ? 'green' : 'orange' }}>
                    {r.complianceApprovedBy ? 'Approved' : 'Pending'}
                  </td>
                  <td style={{ color: r.managementApprovedBy ? 'green' : 'orange' }}>
                    {r.managementApprovedBy ? 'Approved' : 'Pending'}
                  </td>
                  <td style={{ color: r.status === 'final_approved' ? 'green' : 'orange' }}>
                    {r.status === 'final_approved' ? 'Approved' : 'Pending'}
                  </td>
                  <td>{r.status.replace(/_/g, ' ')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
export default Cases;